export default __webpack_public_path__ + "static/media/Cider.0e4966b4.mp3";